import React from 'react';
import AccountHero from '../../components/AccountHero/AccountHero';
import Services from '../../components/Services/Services';
import Expect from '../../components/Expect/Expect';
import Testimonials from '../../components/Testimonials/Testimonials';
import Questions from '../../components/Questions/Questions';
import HomeContact from '../../components/HomeContact/HomeContact';
import { Helmet } from 'react-helmet-async';

const Accounting = () => {

    return (
        <>
            <Helmet>
                {/* Title */}
                <title>Accounting Services Australia | PFGS Business Advisors</title>

                {/* Meta Description */}
                <meta
                    name="description"
                    content="PFGS offers professional accounting services in Australia, including bookkeeping, business advisory, and tax compliance to support your financial growth."
                />

                {/* Canonical URL */}
                <link rel="canonical" href="https://pfgs.com.au/accounting" />

                {/* Meta Robots */}
                <meta
                    name="robots"
                    content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
                />

                {/* Open Graph (Facebook / LinkedIn / WhatsApp) */}
                <meta property="og:title" content="Accounting Services Australia | PFGS Business Advisors" />
                <meta property="og:description" content="PFGS offers professional accounting services in Australia, including bookkeeping, business advisory, and tax compliance to support your financial growth." />
                <meta property="og:url" content="https://pfgs.com.au/accounting" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://pfgs.com.au/pfgs-preview.jpg" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Accounting Services Australia | PFGS Business Advisors" />
                <meta name="twitter:description" content="PFGS offers professional accounting services in Australia, including bookkeeping, business advisory, and tax compliance to support your financial growth." />
                <meta name="twitter:image" content="https://pfgs.com.au/pfgs-preview.jpg" />
            </Helmet>
            <div className="home-page">
                <AccountHero />
                <Services />
                <Expect />
                <Testimonials />
                <HomeContact />
                <Questions />
            </div>
        </>
    );
};

export default Accounting;
